module.exports = __webpack_public_path__ + "static/img/16.10ba779.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/znhy/16.jpg
// module id = Ypbb
// module chunks = 1